<template>
  <div>
    <Header :isactive='6' :ischunrk='true' :key="new Date().getTime()"/>
    <div style="height: 60px;"></div>
    <div id="banner">
      <img src="@/assets/image/banner-rule.jpg" alt="">
    </div>
    <div id="contact-us">
      <div class="us-content">
        <div class="title-content">
          <p class="trans">BEHAVIOR STANDARD</p>
          <p class="title">阳光商业行为标准</p>
        </div>
        <div class="us-list">
          <p class="title-text">以我们的客户、员工以及合作伙伴为核心、我们努力践行以下价值观：</p>
          <p class="title">客户第一</p>
          <p class="text">始终以客户创造价值为先</p>
          <p class="title">信任合作</p>
          <p class="text">始终尊重对方，彼此信任建立合作基础，使得相互得以最佳状态</p>
          <p class="title">拥抱变化</p>
          <p class="text">打破成规、不断拥抱变化寻求突破，持续成长</p>
          <p class="title">积极行动</p>
          <p class="text">积极的方式参与并行动，先做到60分、再努力100分</p>
          <p class="title">诚信正直</p>
          <p class="text">始终坚持做正确的事情，诚实正直，坦率待人</p>
          <p class="title-text">始终以客户价值为核心、我们追求卓越业绩。</p>
          <p class="text">优我科华在与客户、业务伙伴等相关各方的业务关系中，致力遵循高标准的商业行为规范。为了克守此承诺，我们会在业务活动中遵循所有相关法律法规以及《阳光商业行为标准》的要求。</p>
          <p class="text">
            我们要求员工在与外部合作伙伴进行业务往来时体现诚信的价值观，绝不容忍任何不道德或不合法的行为。合作伙伴的支持对我们非常重要，如果您有任何有关优我科华商业行为准则的问题；希望获得关于优我科华业务合规的指引；或者希望报告任何关于优我科华员工涉嫌作出不道德或不合法行为的可疑事件，欢迎您随时联系优我科华。
          </p>
          <p class="text">
            我们建议任何人在提交投诉或问题时，留下包括姓名、联系方式、涉嫌不道德或不合法可疑行为事件细节等详细信息，以便我们在必要时直接和他／她联系。我们会谨慎处理所有咨询与举报，并在法律法规许可范围内竭尽全力确保咨询与举报的保密性。所有的调查将以合法合规为基础。
          </p>
          <p class="text">优我科华严禁他人对任何善意地就涉嫌不道德或不合法行为提供信息或协助调查的人士，进行报复或惩罚。</p>
          <p class="email-msg">优我科华《阳光商业行为标准》联系方式</p>
          <img class="email-img" src="@/assets/image/jubao.png" alt="">

        </div>
      </div>
    </div>
    <Footer/>
    <Top/>
  </div>
</template>

<script>
import Header from '@/components/Header/index.vue'
import Footer from '@/components/Footer/index.vue'
import Top from '@/components/Top/index.vue'

export default {
  components: {'Header': Header, 'Footer': Footer, 'Top': Top},
  data() {
    return {
      ad5: false,
      ad6: false,
      ad7: false,
      ad8: false
    }
  },
  mounted() {
    window.scrollTo(0, 0)
  },
}

</script>
<style lang='scss' scoped>
$active: #13c2c2;
$width: 1200px;
$banner-height: 632px;
$font: 14px;
$trans: 0.25;
$opacity: 0.85;
$time-height: 110px;

#contact-us {
  padding: 120px 0px;

  .us-content {
    width: $width;
    margin: 0 auto;

    .us-list {
      margin-top: 60px;

      p {
        font-size: 16px;
        color: rgba(0, 0, 0, 0.85);
        line-height: 30px;
      }

      .title {
        font-weight: 600;
      }

      .text {
        margin-bottom: 24px;
      }

      .title-text {
        margin-bottom: 48px;
      }

      .email-msg {
        opacity: 0.65;
      }

      .email-img {
        margin: 6px 0px;
      }
    }
  }
}

#banner {
  width: 100%;
  height: 482px;

  img {
    width: 100%;
    min-width: 1920px;
    display: block;
  }
}

.title-content {
  text-align: center;

  .title {
    font-size: 30px;
    height: 36px;
    line-height: 36px;
  }

  .icon {
    margin: 10px auto;
    height: 2px;
    width: 24px;
    background: $active;
  }

  .trans {
    font-size: $font;
    opacity: $trans;
  }
}
</style>
